import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ClubPageState {
  clubData: { [key: string]: { limit: number } };
}

const initialState: ClubPageState = {
  clubData: {},
};

export const clubSlice = createSlice({
  name: 'clubPage',
  initialState,
  reducers: {
    updateClubDataById: (state, action: PayloadAction<{ clubId: string, limit: number }>) => {
      state.clubData[action.payload.clubId] = { limit: action.payload.limit };
    }
  },
});

export const { updateClubDataById } = clubSlice.actions;
export default clubSlice.reducer;